import Request from 'model-fns/request';
import Errors from 'model-fns/errors';
// import Effects from '../../effects';
import xtend from 'xtend';
import cat from 'pull-cat';
import S from 'pull-stream';
S.async = require('pull-async');
import flatMerge from 'pull-flat-merge';
import _ from 'underscore';

function call (fn, onErr, onResp, args) {
    return S.async(function (cb) {
        fn(args, function (err, resp) {
            // console.log(err, resp);
            if (err) return cb(null, onErr(err));
            cb(null, onResp(resp));
        });
    });
}

/*
{
  "ads": {
      "2017-03-17 00:00:00": [
        {
          "clientID": "1000000000",
          "actionDate": "2017-03-17 00:00:00",
          "campiagnID": "46",
          "assetID": "6ccfafed62f4e0240b9f5a4a8f53aef19a98ecaa",
          "counts": "0",
          "clickCount": null,
          "weight": "5"
        }
      ],
    },
    "assetTotalCounts": {
      "6ccfafed62f4e0240b9f5a4a8f53aef19a98ecaa": 0
    },
    "assetTotalClicks": {
      "6ccfafed62f4e0240b9f5a4a8f53aef19a98ecaa": 0
    },
    "totalCounts": 0,
    "totalClicks": 0
  }
}
*/

function VastAnalytics (api) {

    function AnalyticsModel () {
        return {
            resolving: [],
            errors: [],
            data: {
                assetTotalCounts: [],
                assetTotalClicks: []
            }
        };
    }

    AnalyticsModel.effects = {
        get: function (state, msg, ev) {
            return cat([
                S.once(msg.start({ op: 'get', req: ev })),

                S(
                    call(
                        api.vast.getStats,
                        _.compose(S.once, msg.pushError),
                        _.compose(
                            S.once,
                            msg.get,
                            function (resp) {
                                return xtend(resp.data, {
                                    meta: resp.meta
                                });
                            }
                        ),
                        ev
                    ),
                    flatMerge()
                ),

                S.once(msg.resolve({ op: 'get', req: ev }))
            ]);
        }
    };

    AnalyticsModel.update = xtend(Request.update, Errors.update, {
        get: function (state, ev) {
            return xtend(state, {
                data: ev
            });
        }
    });

    return AnalyticsModel;
}

export default VastAnalytics;
